module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAAXNSR0IArs4c6QAAARZJREFUOE/VlK9vwlAUhT+SiQkEAjExgUBMIBCI/f8KgUBMTCAQiEkEYmKCfM27DX28/qAJYjdpmvS+e3rOuaed8ISaPAGT/wW6AabABdiNtGMBeFlb5b8CAr8AJ+DwILDzn2nmCBzD03dgmRp74DwQWCISEtgZZxuLWgFz4DfZ8DcAWCISckZA7w3Q4ls7gN+Aj9T/Bn7ibB6pGbBOTb3V41Ip13PeKx9vD5VyGv4qX0mmIi8XI6Byt3mzLfyykHXJ34iPLzWClY99TO23xWyQPV2fqUkwEdZXsiF8dCkup1h9335ERqnmMCJXx6eE2gd6G7OY18fS8mr8PtDc37v4jGEaM8r2p9PI41hP2+Y6nw+R/zDwFbCyNh02d5YGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/Slice 18@2x.png
// module id = jmJt
// module chunks = 2